import { QuestionnaireState, RootState } from '@/types/store'
import {
  ConditionEntity,
  GetQuestionnairesResponse,
  QuestionEntity,
  QuestionnairePageEntity,
} from '../../../api/@types'
import { GetterTree } from 'vuex'

export interface QuestionnaireGetters
  extends GetterTree<QuestionnaireState, RootState> {
  questionnaire: (state: QuestionnaireState) => GetQuestionnairesResponse
  questionnaires: (state: QuestionnaireState) => GetQuestionnairesResponse[]
  pages: (state: QuestionnaireState) => QuestionnairePageEntity[]
  page: (
    state: QuestionnaireState,
  ) => (id: number) => QuestionnairePageEntity | undefined
  question: (
    state: QuestionnaireState,
  ) => (pageId: number, id: number) => QuestionEntity | undefined
  conditions: (
    state: QuestionnaireState,
  ) => (pageId: number, questionId: number) => ConditionEntity[]
  condition: (
    state: QuestionnaireState,
  ) => (
    pageId: number,
    questionId: number,
    id: number,
  ) => ConditionEntity | undefined
}

export const getters: QuestionnaireGetters = {
  questionnaire(state) {
    return state.questionnaire
  },
  questionnaires(state) {
    return state.questionnaires
  },
  isQuestionnaireLoading(state): QuestionnaireState['isQuestionnaireLoading'] {
    return state.isQuestionnaireLoading
  },
  pages: state => state.questionnaire.pages,
  page: state => (id: number) => {
    return state.questionnaire.pages.find(page => page.id === Number(id))
  },
  question: state => (pageId: number, id: number) => {
    const page = state.questionnaire.pages.find(
      page => page.id === Number(pageId),
    )
    return page?.questions.find(q => q.id === Number(id))
  },
  conditions: state => (pageId: number, questionId: number) => {
    const conditions = state.questionnaire.pages
      .find(page => page.id === Number(pageId))
      ?.questions.find(question => question.id === Number(questionId))
      ?.conditions
    return conditions ?? []
  },
  condition: state => (pageId: number, questionId: number, id: number) => {
    const conditions = state.questionnaire.pages
      .find(page => page.id === Number(pageId))
      ?.questions.find(question => question.id === Number(questionId))
      ?.conditions
    return conditions?.find(condition => condition.id === Number(id))
  },
  completions(state) {
    return state.completeQuestionnaires
  },
}
